import { render, staticRenderFns } from "./import-partners-list.vue?vue&type=template&id=3417e5ae&scoped=true&"
import script from "./import-partners-list.vue?vue&type=script&lang=js&"
export * from "./import-partners-list.vue?vue&type=script&lang=js&"
import style0 from "./import-partners-list.vue?vue&type=style&index=0&id=3417e5ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3417e5ae",
  null
  
)

export default component.exports